import styled from 'styled-components';

export const Container = styled.div`
  float: left;
  display: flex;
  flex-direction: column;
  font-size: 1.6rem;
  font-weight: 500;
  color: #ccc;
  width: 100%;
  padding: 3rem;
  text-align: center;
  border-radius: 0.8rem;

  @media (max-width: 1024px) {
    max-width: 100%;
    font-size: 1rem;
  }
`;
